import React from "react"
import { Row, Col, FormGroup, Input, Container } from "reactstrap"
import { Route } from "react-router-dom"
import { dynamiclyActivate } from "../../i18n"

const buttonStyle = {
  backgroundColor: "#C0C9D1",
  flex: "1",
  color: "white",
}

const rowStyle = {
  fontFamily: "Fira Sans",
  fontSize: "22px",
  textAlign: "center",
  fontWeight: "bold",
}

const headerStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "bolder",
  fontSize: "1.8em",
  textAlign: "center",
  paddingBottom: "0.5em",
}

const MainMenu = () => {
  const handleInput = (locale) => {
    localStorage.setItem("lang", locale)
    dynamiclyActivate(locale)
  }

  return (
    <div>
      <div>
        <h6 style={headerStyle}>LANGUAGE/LANGAGE</h6>
      </div>
      <br />
      <Container>
        <Route
          exact
          path="/"
          render={() => (
            <React.Fragment>
              <Row style={rowStyle}>
                <Col>
                  <FormGroup>
                    <Input
                      type="submit"
                      value="العربية"
                      name="submit"
                      className="btn"
                      onClick={() => {
                        handleInput("ar")
                      }}
                      style={{
                        buttonStyle,
                        backgroundColor: "#F4B223",
                        color: "#FFFFFF",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={rowStyle}>
                <Col>
                  <FormGroup>
                    <Input
                      type="submit"
                      value="ENGLISH"
                      name="submit"
                      className="btn"
                      onClick={() => handleInput("en")}
                      style={{
                        buttonStyle,
                        backgroundColor: "#F4B223",
                        color: "#FFFFFF",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row style={rowStyle}>
                <Col>
                  <FormGroup>
                    <Input
                      type="submit"
                      value="FRANÇAIS"
                      name="submit"
                      className="btn"
                      onClick={() => handleInput("fr")}
                      style={{
                        buttonStyle,
                        backgroundColor: "#F4B223",
                        color: "#FFFFFF",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={rowStyle}>
                <Col>
                  <FormGroup>
                    <Input
                      type="submit"
                      value="SPANISH"
                      name="submit"
                      className="btn"
                      onClick={() => handleInput("es")}
                      style={{
                        buttonStyle,
                        backgroundColor: "#F4B223",
                        color: "#FFFFFF",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={rowStyle}>
                <Col>
                  <FormGroup>
                    <Input
                      type="submit"
                      value="KISWAHILI"
                      name="submit"
                      className="btn"
                      onClick={() => handleInput("sw")}
                      style={{
                        buttonStyle,
                        backgroundColor: "#F4B223",
                        color: "#FFFFFF",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={rowStyle}>
                <Col>
                  <FormGroup>
                    <Input
                      type="submit"
                      value="PORTUGUESE"
                      name="submit"
                      className="btn"
                      onClick={() => {
                        handleInput("pt")
                      }}
                      style={{
                        buttonStyle,
                        backgroundColor: "#F4B223",
                        color: "#FFFFFF",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={rowStyle}>
                <Col>
                  <FormGroup>
                    <Input
                      type="submit"
                      value="LEBANESE ENGLISH"
                      name="submit"
                      className="btn"
                      onClick={() => {
                        handleInput("lb")
                      }}
                      style={{
                        buttonStyle,
                        backgroundColor: "#F4B223",
                        color: "#FFFFFF",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </React.Fragment>
          )}
        />
      </Container>
    </div>
  )
}
export default MainMenu
